import { useMemo } from "react";
import { EMPTY_PREVIEW } from "./constants";

const getPreviewFromRow = (row) => {
  if (!row) return EMPTY_PREVIEW;

  let parsed = null;
  try {
    const source = row.messageJson || row.message_json;
    parsed = typeof source === "string" ? JSON.parse(source) : source;
  } catch {
    return EMPTY_PREVIEW;
  }

  if (!parsed?.messages?.length) return EMPTY_PREVIEW;

  const first = parsed.messages[0];

  let text = "";

  if (typeof first.message === "string") {
    text = first.message;
  }

  if (typeof first.message === "object" && first.message?.content) {
    text = first.message.content;
  }

  if (!text) return EMPTY_PREVIEW;

  const buttonsFromMessage =
    typeof first.message === "object" && Array.isArray(first.message?.buttons)
      ? first.message.buttons
      : [];
  const buttonsFromItem = Array.isArray(first.buttons) ? first.buttons : [];

  return {
    channel: row.channel_type,
    messages: [
      {
        id: first.id || "auto-reply",
        type: "text",
        content: text,
        fromMe: first.fromMe ?? true,
        buttons: buttonsFromMessage.length ? buttonsFromMessage : buttonsFromItem,
      },
    ],
  };
};

export const useTemplatePreview = (selectedRows, rows) => {
  return useMemo(() => {
    if (!selectedRows.length) return EMPTY_PREVIEW;

    const selectedId = selectedRows[0];
    const row = rows.find((r) => r.id === selectedId);

    return getPreviewFromRow(row);
  }, [selectedRows, rows]);
};
